// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/TrustSection.css */
.trust-section {
  padding: 80px 8vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(
    180deg,
    #ffffff 0%,
    #f8fafc 50%,
    #f0f9ff 100%
  );
  position: relative;
  z-index: 2;
  box-sizing: border-box;
}

.trust-wrap {
  max-width: 1200px;
  width: 100%;
  margin: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 40px;
  align-items: center;
}

.trust-image {
  position: relative;
  border-radius: 28px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(44, 62, 80, 0.25);
}

.trust-image img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.5s ease;
}

.trust-image:hover img {
  transform: scale(1.02);
}

.trust-content {
  max-width: 520px;
}

.trust-eyebrow {
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: #7ED321;
  margin-bottom: 20px;
  display: inline-block;
}

.trust-content h2 {
  font-size: 40px;
  font-weight: 800;
  line-height: 1.2;
  margin: 0 0 20px;
  color: #1F2937;
  letter-spacing: -0.5px;
}

.trust-content p {
  font-size: 16px;
  line-height: 1.7;
  color: #4B5563;
  margin: 0 0 28px;
  max-width: 90%;
}

.trust-points {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px 16px;
  margin: 30px 0;
  align-items: flex-start;
}

.trust-point strong {
  font-size: 18px;
  font-weight: 700;
  color: #2C3E50;
  display: block;
  margin-bottom: 4px;
  line-height: 1.4;
  letter-spacing: -0.01em;
}

.trust-point span {
  font-size: 14px;
  font-weight: 400;
  color: #4B5563;
  display: block;
  line-height: 1.5;
  opacity: 0.9;
}

.trust-cta {
  padding: 14px 32px;
  border-radius: 999px;
  border: none;
  background: linear-gradient(90deg, #7ED321 0%, #4CAF50 100%);
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(126, 211, 33, 0.3);
}

.trust-cta:hover {
  transform: translateY(-3px);
  box-shadow: 0 25px 55px rgba(126, 211, 33, 0.45);
}

/* Responsive */
@media (max-width: 1024px) {
  .trust-section {
    padding: 70px 6vw;
  }

  .trust-content h2 {
    font-size: 36px;
  }

  .trust-content p {
    font-size: 15px;
  }
}

@media (max-width: 900px) {
  .trust-wrap {
    grid-template-columns: 1fr;
    gap: 32px;
  }

  .trust-content h2 {
    font-size: 32px;
  }
  
  .trust-section {
    padding: 60px 6vw;
    min-height: auto;
  }
  
  .trust-image {
    max-width: 500px;
    margin: 0 auto;
  }

  .trust-content {
    max-width: 100%;
  }

  .trust-content p {
    max-width: 100%;
  }
}

@media (max-width: 768px) {
  .trust-section {
    padding: 50px 5vw;
  }

  .trust-eyebrow {
    font-size: 11px;
    margin-bottom: 16px;
  }

  .trust-content h2 {
    font-size: 28px;
    margin-bottom: 16px;
  }

  .trust-content p {
    font-size: 15px;
    margin-bottom: 24px;
  }

  .trust-points {
    grid-template-columns: 1fr;
    gap: 16px;
    margin: 24px 0;
  }

  .trust-point strong {
    font-size: 17px;
  }

  .trust-point span {
    font-size: 13px;
  }

  .trust-image {
    border-radius: 20px;
  }
}

@media (max-width: 480px) {
  .trust-section {
    padding: 40px 4vw;
  }

  .trust-wrap {
    gap: 24px;
  }

  .trust-eyebrow {
    font-size: 10px;
  }

  .trust-content h2 {
    font-size: 24px;
    margin-bottom: 12px;
  }

  .trust-content p {
    font-size: 14px;
    margin-bottom: 20px;
  }

  .trust-points {
    gap: 12px;
    margin: 20px 0;
  }
  
  .trust-point strong {
    font-size: 16px;
    margin-bottom: 2px;
  }

  .trust-point span {
    font-size: 12px;
  }
  
  .trust-cta {
    width: 100%;
    padding: 12px 24px;
    font-size: 15px;
  }

  .trust-image {
    border-radius: 16px;
  }
}

.section-header h2 {
  font-size: 40px;
  color: #0f172a;
  margin-bottom: 16px;
  line-height: 1.2;
}

.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 30px;
  margin-bottom: 80px;
}

.stat-card {
  background: white;
  border-radius: 16px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

/* .stat-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 */`, "",{"version":3,"sources":["webpack://./src/components/TrustSection.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE,iBAAiB;EACjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB;;;;;GAKC;EACD,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,4DAA4D;EAC5D,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2CAA2C;EAC3C,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;;iBAEiB","sourcesContent":["/* src/components/TrustSection.css */\n.trust-section {\n  padding: 80px 8vw;\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  background: linear-gradient(\n    180deg,\n    #ffffff 0%,\n    #f8fafc 50%,\n    #f0f9ff 100%\n  );\n  position: relative;\n  z-index: 2;\n  box-sizing: border-box;\n}\n\n.trust-wrap {\n  max-width: 1200px;\n  width: 100%;\n  margin: auto;\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 40px;\n  align-items: center;\n}\n\n.trust-image {\n  position: relative;\n  border-radius: 28px;\n  overflow: hidden;\n  box-shadow: 0 30px 80px rgba(44, 62, 80, 0.25);\n}\n\n.trust-image img {\n  width: 100%;\n  height: auto;\n  display: block;\n  transition: transform 0.5s ease;\n}\n\n.trust-image:hover img {\n  transform: scale(1.02);\n}\n\n.trust-content {\n  max-width: 520px;\n}\n\n.trust-eyebrow {\n  font-size: 12px;\n  font-weight: 800;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  color: #7ED321;\n  margin-bottom: 20px;\n  display: inline-block;\n}\n\n.trust-content h2 {\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 1.2;\n  margin: 0 0 20px;\n  color: #1F2937;\n  letter-spacing: -0.5px;\n}\n\n.trust-content p {\n  font-size: 16px;\n  line-height: 1.7;\n  color: #4B5563;\n  margin: 0 0 28px;\n  max-width: 90%;\n}\n\n.trust-points {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 20px 16px;\n  margin: 30px 0;\n  align-items: flex-start;\n}\n\n.trust-point strong {\n  font-size: 18px;\n  font-weight: 700;\n  color: #2C3E50;\n  display: block;\n  margin-bottom: 4px;\n  line-height: 1.4;\n  letter-spacing: -0.01em;\n}\n\n.trust-point span {\n  font-size: 14px;\n  font-weight: 400;\n  color: #4B5563;\n  display: block;\n  line-height: 1.5;\n  opacity: 0.9;\n}\n\n.trust-cta {\n  padding: 14px 32px;\n  border-radius: 999px;\n  border: none;\n  background: linear-gradient(90deg, #7ED321 0%, #4CAF50 100%);\n  color: white;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(126, 211, 33, 0.3);\n}\n\n.trust-cta:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 25px 55px rgba(126, 211, 33, 0.45);\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .trust-section {\n    padding: 70px 6vw;\n  }\n\n  .trust-content h2 {\n    font-size: 36px;\n  }\n\n  .trust-content p {\n    font-size: 15px;\n  }\n}\n\n@media (max-width: 900px) {\n  .trust-wrap {\n    grid-template-columns: 1fr;\n    gap: 32px;\n  }\n\n  .trust-content h2 {\n    font-size: 32px;\n  }\n  \n  .trust-section {\n    padding: 60px 6vw;\n    min-height: auto;\n  }\n  \n  .trust-image {\n    max-width: 500px;\n    margin: 0 auto;\n  }\n\n  .trust-content {\n    max-width: 100%;\n  }\n\n  .trust-content p {\n    max-width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .trust-section {\n    padding: 50px 5vw;\n  }\n\n  .trust-eyebrow {\n    font-size: 11px;\n    margin-bottom: 16px;\n  }\n\n  .trust-content h2 {\n    font-size: 28px;\n    margin-bottom: 16px;\n  }\n\n  .trust-content p {\n    font-size: 15px;\n    margin-bottom: 24px;\n  }\n\n  .trust-points {\n    grid-template-columns: 1fr;\n    gap: 16px;\n    margin: 24px 0;\n  }\n\n  .trust-point strong {\n    font-size: 17px;\n  }\n\n  .trust-point span {\n    font-size: 13px;\n  }\n\n  .trust-image {\n    border-radius: 20px;\n  }\n}\n\n@media (max-width: 480px) {\n  .trust-section {\n    padding: 40px 4vw;\n  }\n\n  .trust-wrap {\n    gap: 24px;\n  }\n\n  .trust-eyebrow {\n    font-size: 10px;\n  }\n\n  .trust-content h2 {\n    font-size: 24px;\n    margin-bottom: 12px;\n  }\n\n  .trust-content p {\n    font-size: 14px;\n    margin-bottom: 20px;\n  }\n\n  .trust-points {\n    gap: 12px;\n    margin: 20px 0;\n  }\n  \n  .trust-point strong {\n    font-size: 16px;\n    margin-bottom: 2px;\n  }\n\n  .trust-point span {\n    font-size: 12px;\n  }\n  \n  .trust-cta {\n    width: 100%;\n    padding: 12px 24px;\n    font-size: 15px;\n  }\n\n  .trust-image {\n    border-radius: 16px;\n  }\n}\n\n.section-header h2 {\n  font-size: 40px;\n  color: #0f172a;\n  margin-bottom: 16px;\n  line-height: 1.2;\n}\n\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 30px;\n  margin-bottom: 80px;\n}\n\n.stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 40px 20px;\n  text-align: center;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);\n  transition: all 0.3s ease;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n/* .stat-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
